import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Model from "../ModelWithoutCross";
import { SubmitBtn, PreviewBtn } from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import Loading from "../Loading";
import { useTranslation } from "react-i18next";

const IsDocsModel = ({
  setIsDocsModel,
  selectedAppId,
  appStatus
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // console.log(appStatus)

  
  const navigateTo = () =>{
    setIsDocsModel(false)
    navigate("/my-applications");
  }

  return (
    <Model width={"w-11/12 max-w-lg"} setOpenModel={setIsDocsModel}>
      {/* {deleteDeviceLoading && <Loading />} */}
      {/* {!deleteDeviceLoading && ( */}
        <>
          {appStatus == 10 &&
          <Title>{t("RegistrationProceedHeadingEdit")}</Title>
          }
          {appStatus != 10 &&
          <Title>{t("RegistrationProceedHeading")}</Title>
          }
          <div className="w-full flex items-center justify-center space-x-10 mt-8">
            <Submit onClick={() => navigate('/submit-docs/'+selectedAppId)}>{t("AttachDocs")}</Submit>
            {/* <Submit >Attach Docs</Submit> */}
            {appStatus == 10 &&
                <Preview onClick={() => navigateTo()}>{t("NotNeeded")}</Preview>
            }
            {appStatus != 10 &&
              <Preview onClick={() => navigateTo()}>{t("DoItLater")}</Preview>
            }
          </div>
        </>
      {/* )} */}
    </Model>
  );
};

const Title = tw.h2` text-lg md:text-xl text-gray-600 font-medium mb-6 text-center`;
const Submit = tw.button`px-8 py-3 text-sm bg-green-400 text-white rounded hover:bg-gree-100`;
const Preview = tw.button`px-8 py-3 text-sm bg-gray-100 text-gray-600 rounded hover:bg-gray-200`;

export default IsDocsModel;
